import React, { useState } from "react";
import TaskTable from "../Task/RevampedAllTask";
import CustomDialog from "../UniversalComponents/CustomDialog";
import { useNavigate, useParams } from "react-router-dom";

const AddTask = ({
  leadType = "task",
  customerData,
  subNavitems,
  propTemplateId,
  fullScreen = false,
  moduleTaskId,
  disableAddMode = false,
}) => {
  const [view, setView] = useState("Day");

  const navigate = useNavigate();
  const { id: customerId, tab: tabValue } = useParams();

  return (
    <TaskTable
      customerTask={true}
      setView={setView}
      view={view}
      leadType={leadType}
      disableLeadTypeChange
      customerData={customerData}
      subNavitems={subNavitems}
      propTemplateId={propTemplateId}
      fullScreen={fullScreen}
      moduleTaskId={moduleTaskId}
      disableAddMode={disableAddMode}
    />
  );
};

export default AddTask;
